import { LuChevronDown } from "@/Components/Icons/Icons";

  export default {
    row1 : [
    {
      column: "column1",
      columnWidth: "48%",
      rows: {
       row1: [
          {
            name: "exportRequirementDocumentName",
            label: "Document Name",
            component: "dropdown",
            width: "100%",
            endIconName:LuChevronDown,
             options: [
            { label: "Texttile Test Certificate", value: "Texttile Test Certificate" },
            { label: "Invoice Copy", value: "Invoice Copy" },
            { label: "Packing List", value: "Packing List" },
            { label: "COO", value: "COO" },
           
          ],
          // placeholder: "Texttile Test Certificate",
          }
        ],
      },
    },
    {
      column: "colum2",
      columnWidth: "48%",
      rows: {
        row1: [
          {
            name: "exportRequirementDate", 
            label: "Date",
            component: "dateselector",
            width: "100%",
          },
        ],
         
        
      },
    },
  ]
  };
  
